<template>
  <el-container class="task-examineLayout">
    <el-header class="nav-container" :height="isMobile ? 'auto' : '60px'">
      <navbar nav-index="/taskExamine" @nav-items-click="navClick" />
    </el-header>
    <el-container>
      <sidebar :items="taskExamineRouters" class="sidebar-container" />

      <el-main id="workLog-main-container" style="padding:15px;">
        <app-main />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { Navbar, Sidebar, AppMain } from "./components";
import { mapGetters, mapState } from "vuex";

export default {
  name: "TaskExamineLayout",

  components: {
    Navbar,
    Sidebar,
    AppMain,
  },

  data() {
    return {};
  },

  computed: {
    ...mapState(["isMobile"]),
    ...mapGetters(["taskExamineRouters"]),
  },

  created() {},

  methods: {
    navClick(index) {},
  },
};
</script>

<style lang="scss" scoped>
@import "./styles/common.scss";
@media screen and (max-width: 768px) {
  .task-examineLayout {
    .nav-container {
      z-index: 10000 !important;
    }
    #workLog-main-container {
      width: 100vw !important;
      padding: 2.6667vw 0 !important;
    }
  }
}
@media screen and (min-width: 769px) {
  .nav-container {
    min-width: 1200px;
  }
}
.el-container {
  min-height: 0;
  height: 100%;
}
.aside-container {
  position: relative;
  background-color: #2d3037;
  box-sizing: border-box;
  overflow: visible;
}

.nav-container {
  padding: 0;
  box-shadow: 0px 1px 2px #dbdbdb;
  z-index: 100;
  min-width: 1200px;
}
.quick-add {
  height: 178px;
}
</style>
